import { render } from "./choiseCompanyClientNew.vue?vue&type=template&id=9741ce54&scoped=true"
import script from "./choiseCompanyClientNew.vue?vue&type=script&lang=js"
export * from "./choiseCompanyClientNew.vue?vue&type=script&lang=js"

import "./choiseCompanyClientNew.vue?vue&type=style&index=0&id=9741ce54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9741ce54"]])

export default __exports__